module.exports = __webpack_public_path__ + "static/media/20-12.cb7a8b3d.mp3";